import styled, { css } from 'styled-components';
import { generateClassNames, applyDisplayNames } from '../../utils/functions';
import ButtonStyled from '../button/button.styles';
import { colorButtonMixin, squarePaddingMixin } from './icon-button.mixin';
import { ButtonSize, IconButtonColor } from '../../utils/types';
var baseClassName = 'IconButton';
var IconButton = /*#__PURE__*/styled(ButtonStyled.Button).attrs({
  className: generateClassNames(baseClassName, 'root')
}).withConfig({
  componentId: "sc-10edh45-0"
})(function (_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? IconButtonColor.Secondary : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? ButtonSize.Md : _ref$size;
  return css(["", " ", ""], squarePaddingMixin[size], colorButtonMixin[color]);
});
var Styled = applyDisplayNames({
  IconButton: IconButton
});
export default Styled;